<template>
  <div class="form-group" v-bind:class="[colClass, classError]">
    <label class="form-label" v-bind:class="{'bold': required || bold}">{{ label }} <span class="t-error" v-if="required">*</span></label>
    <div class="form-control">
      <loader :loading="loading"/>
      <slot/>
      <span class="t-error dsblock" v-if="error.message !== null && error !== false">
        {{ getErrorMessage() }}
      </span>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/template/Loader'

  export default {
    computed: {
      colClass () {
        return `l-col-${this.columns}@md`
      },
      isNumber () {
        return !isNaN(this.error.value)
      }
    },
    props: {
      columns: {
        type: Number,
        default: 3
      },
      label: {
        type: String,
        required: true
      },
      error: {
        type: [Object, Boolean],
        default: () => { return {message: null, value: null} },
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      bold: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      classError () {
        return {
          'i-error': this.error.message.length
        }
      },
      getErrorMessage () {
        let value = this.error.value
        if (this.$te(`${this.error.value}.label`)) {
          value = this.$t(`${this.error.value}.label`)
        }

        let message = this.$tc(`${this.error.message}.label`, this.error.value, { msg: value })

        if (this.isNumber && this.$te(`validationError.${this.error.message}.label`, value, { msg: value })) {
          message = this.$tc(`validationError.${this.error.message}.label`, value, {msg: value})
        }

        if (!this.isNumber && this.$te(`validationError.${this.error.message}.label`, { msg: value })) {
          if (value.split('-').length === 3) {
            value = new Date(value).toLocaleDateString('pt-br')
          }
          message = this.$t(`validationError.${this.error.message}.label`, {msg: value})
        }

        return message
      }
    },
    components: {
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .t-error
    font-weight: bold

  .bold
    font-weight: bold

  .dsblock
    display: block
</style>



// WEBPACK FOOTER //
// FormGroup.vue?80eb6764